module.exports = __webpack_public_path__ + "static/img/t3.d0349875.png";